const MOBILE_BREAK_POINT = 1024;

export class Utils {

  // -----------------------------------------------
  // viewport切り替え（引数breakpointの幅未満はviewportを固定にする）
  // -----------------------------------------------
  static switchViewport(breakpoint) {
    // viewportのセレクタ取得
    const viewport = document.querySelector('meta[name="viewport"]');
    const value = window.outerWidth > breakpoint ? 'width=device-width,initial-scale=1,viewport-fit=cover' : 'width=' + breakpoint;
    if (viewport.getAttribute('content') !== value) {
      viewport.setAttribute('content', value);
    }
  }

  // -----------------------------------------------
  // 指定されたidのページの場合True返却
  // -----------------------------------------------
  static isPage(id) {
    // ★bodyタグに付与されたidと比較判定する
    return document.querySelector('body').getAttribute('id') === id ? true : false;
  }

  // -----------------------------------------------
  // ブラウザがIEの場合True返却
  // -----------------------------------------------
  static isIE() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
      return true;
    } else {
      return false;
    }
  }

  // -----------------------------------------------
  // モバイル端末なら true 、それ以外なら false を返す
  // -----------------------------------------------
  static isMobile() {
    return window.innerWidth <= MOBILE_BREAK_POINT;
  }

  // -----------------------------------------------
  // PCなら true 、それ以外なら false を返す
  // -----------------------------------------------
  static isPc() {
    return !this.isMobile();
  }

  // -----------------------------------------------
  // ブラウザの縦のサイズを取得し、セットする（iOS対策）
  // -----------------------------------------------
  static setHeightFromWindowHight(target) {
    target = document.querySelector(target);
    if (!target) return;

    const hSize = window.innerHeight;
    let paddingTop = 0;
    let paddingBottom = 0;
    // if (Utils.isPc()) {
    //   paddingTop = Number(getComputedStyle(target).paddingTop.replace('px', ''));
    //   paddingBottom = Number(getComputedStyle(target).paddingBottom.replace('px', ''));
    // }
    target.style.height = hSize + paddingTop + paddingBottom + 'px';
  }

  // -----------------------------------------------
  // ページ内リンクの場合Trueを返却する
  // -----------------------------------------------
  static isInPageLink(event) {
    // ブラウザのURL取得（プロトコル「https:」は削除）
    let pageUrl = location.origin + location.pathname;
    pageUrl = pageUrl.replace(location.protocol, '');

    // 最後の文字が「/」なら削除する
    if (pageUrl.slice(-1) === '/') {
      pageUrl = pageUrl.slice(0, -1);
    }

    // リンクのhref取得（プロトコル「https:」は削除）
    let linkHref = event.currentTarget.getAttribute('href');
    linkHref = linkHref.replace(location.protocol, '');

    // 差分取得
    let diff = linkHref.replace(pageUrl, '');

    // 先頭の文字が「/」なら削除する
    if (diff.slice(0, 1) === '/') {
      diff = diff.slice(1);
    }

    if (diff.indexOf('#') === 0 || diff === '') {
      return true;
    } else {
      return false;
    }
  }

  // -----------------------------------------------
  // ポジション移動（スムーズスクロール）
  // -----------------------------------------------
  static movePosition(target) {
    // href属性値取得
    const href = target.getAttribute('href');
    if (href.indexOf('#') < 0) {
      // #がなければ抜ける
      // 親イベントを実行させるためtrue返却
      return true;
    }

    // href属性値からターゲットとなるセレクターを取得する
    let targetSelector = '';
    if (href === '#') {
      targetSelector = 'html';
    } else {
      // 末尾の「#○○○」だけを切り出す
      const id = href.split('#');
      targetSelector = '#' + id[id.length - 1];
    }

    if (!document.querySelector(targetSelector)) {
      // ターゲット要素が存在しない場合は何もしないで抜ける
      return false;
    }

    // 移動処理
    // .headerクラスがついた要素の高さを取得
    const header = document.querySelector('header').clientHeight;
    // const header = 80;
    // const speed = 1000;

    // 位置を取得（ヘッダー分の高さを引く、その分だけ移動すればヘッダーと被らない）
    const position = document.querySelector(targetSelector).getBoundingClientRect().top + window.pageYOffset - header + 100;
    window.scrollTo({ top: position, behavior: 'smooth' });
    return false;
  }

  // -----------------------------------------------
  //iOS（iPadOSを含む）かどうかのUA判定
  // -----------------------------------------------
  static isiOS() {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || (ua.indexOf('macintosh') > -1 && 'ontouchend' in document);
  }

  // -----------------------------------------------
  // 文字列の場合はTrueを返却する
  // -----------------------------------------------
  static isString(value) {
    if (typeof value === 'string' || value instanceof String) {
      return true;
    } else {
      return false;
    }
  }
}
